// https://app.growthbook.io/features/pen-5840-v1
export const CORE_MEMBERSHIP_LANGUAGE_CLEANUP_FLAG_NAME = 'pen-5840_v1'
